/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'format-align-bottom': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M13 9l2.5-2.5 1.42 1.42L12 12.84 7.08 7.92 8.5 6.5 11 9V3h2v6M3 15h18v2H3v-2m0 4h10v2H3v-2z"/>'
  }
})
